import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import QuizDiagnosticsBookTitle from './QuizDiagnosticsBookTitle'
import QuizDiagnosticsProgressBar from './QuizDiagnosticsProgressBar'
import { QUIZ_DIAGNOSTICS_COURSE_BAR_WIDTH } from '../utils/quizDiagnosticsBarLayout'

type QuizDiagnosticsAllProps = {
  percent: number
}

const QuizDiagnosticsAll = ({
  percent
}: QuizDiagnosticsAllProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Container>
      <QuizDiagnosticsBookTitle>
        {t('quizDiagnostics.all.title')}
      </QuizDiagnosticsBookTitle>
      <QuizDiagnosticsProgressBar
        color='gold'
        percent={percent}
        title={t('quizDiagnostics.all.label')}
        subtitle={t('quizDiagnostics.all.labelDescription')}
        barWidth={QUIZ_DIAGNOSTICS_COURSE_BAR_WIDTH}
      />
    </Container>
  )
}

export default QuizDiagnosticsAll

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;
  padding: 0;
  box-sizing: border-box;
`
